export interface Insurer {
  code?: string;
}

export interface InsurerData {
  dossierId?: number;
  callAgent?: string;
  callAgentFirstname?: string;
  callAgentLastname?: string;
  /** @deprecated Read only for migration. Add comments to Dossier.dossierComments. */
  comment?: string;
  other?: string;
  /** @deprecated Read only for migration. Add comments to Dossier.dossierComments. */
  abandonmentComment?: string;
  /** @deprecated Read only for migration. Add comments to Dossier.dossierComments. */
  finishLaterComment?: string;
  rriNumber?: string;
}
